import "twin.macro";

import { Radio } from "@mui/material";

import { DemandPlanVariantStatusMeta } from "@models/DemandPlanVariant";

import { ControlledRadioGroup } from "../../../utils/forms";
import { useFilterContext } from "../filterContext";
import Chip from "./Chip";

const Popper = ({ titlePrefix = "" }) => {
  const { control } = useFilterContext();

  return (
    <div tw="min-w-[200px]">
      <h4 tw="text-neutral-600 my-4 px-3">{titlePrefix}Status is</h4>

      <ControlledRadioGroup tw="w-full" name="status" control={control}>
        {Array.from(DemandPlanVariantStatusMeta.entries()).map(
          ([key, value]) => (
            <label
              key={key}
              tw="flex items-center px-3 border-t border-neutral-200 text-sm hover:bg-neutral-100 cursor-pointer"
            >
              <Radio size="small" value={key} edge="start" />
              {value.label}
            </label>
          )
        )}
      </ControlledRadioGroup>
    </div>
  );
};

const StatusChip = ({ titlePrefix = "", ...props }) => {
  const { filterValues } = useFilterContext();
  const activeStatus = filterValues["status"];
  const activeStatusText =
    activeStatus && DemandPlanVariantStatusMeta.get(activeStatus)?.label;

  return (
    <Chip {...(props as any)}>
      <span>{titlePrefix}Status is&nbsp;</span>
      <b>{activeStatusText}</b>
    </Chip>
  );
};

const DemandPlanVariantStatusFilter = {
  name: "demandPlanVariantStatus",
  Chip: StatusChip,
  Popper: Popper,
  menuText: "Status",
  formControls: ["status"],
};

export default DemandPlanVariantStatusFilter;
